export const GET_MIRROR_DATA = 'mirror/GET_MIRROR_DATA'
